module.exports = __webpack_public_path__ + "img/calendar-ico-white.3c46676f.svg";